// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

         /* Main Nav Dropdown */
        let primaryNav = document.getElementById('primary-nav');
        if(primaryNav){
            primaryNav.querySelectorAll('li').forEach(function(primary_nav) {
                primary_nav.addEventListener("mouseover", (event) => {
                    primary_nav.classList.add('hover');
                    if(primary_nav.querySelector('ul.submenu')){
                        primary_nav.querySelector('ul.submenu').classList.add('open');
                    }
                });
                primary_nav.addEventListener("mouseout", (event) => {
                    primary_nav.classList.remove('hover');
                    if(primary_nav.querySelector('ul.submenu')){
                        primary_nav.querySelector('ul.submenu').classList.remove('open');
                    }
                });
            });
        }

	if(document.querySelector('.inner ul li .sub-sub-menu')){
		let allItemsMenu = document.querySelectorAll('.inner ul li');
		let allSubmenus = document.querySelectorAll('.inner ul li .sub-sub-menu');

		allItemsMenu.forEach((menu)=>{
			if(menu.querySelector('.sub-sub-menu')){
				menu.classList.add('has-menu');
				menu.querySelector('a').addEventListener('click', (e)=>{
					e.preventDefault();
					let sibblingSubmenu = menu.querySelector('a').nextElementSibling;
					allSubmenus.forEach((submenu)=>{
						if(submenu == sibblingSubmenu){
							submenu.classList.toggle('show');
						}else{
							submenu.classList.remove('show');
						}
					});
					document.querySelectorAll('.inner ul li').forEach((menus2)=>{
						if(menus2 == menu){
							menu.classList.toggle('show');
						}else{
							menus2.classList.remove('show');
						}
					})
				})
				if(menu.querySelector('a.active')){
					menu.classList.add('show');
					menu.querySelector('.sub-sub-menu').classList.add('show');
				}
			}
		})
	}
		

    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
		if ('scrollRestoration' in history) {
			history.scrollRestoration = 'manual';
		}
		if (document.querySelector('.js-scroll-logo')) {
			console.log("test");
			
			  scrollDownAction(0, 'scroll');
		}
      
	};


    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	//email signup animation 
	if(document.querySelector('#email-signup')){
		document.querySelector('#email-signup_FNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.querySelector('#email-signup_LNAME').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})
		document.querySelector('#email-signup_email_address').addEventListener('focus', function(){
			this.parentElement.classList.add('moved');
		})

	}

		// Tag Bg
        if (document.querySelector('.tabs-block__filter li')) {
            let tabsPosts = document.querySelectorAll('.tabs-block__filter li');
            let lastClick = null;

            tabsPosts.forEach((tab)=>{
                tab.addEventListener('click', (e)=>{
                    let tag = e.target.dataset.tag;
                    let items = document.querySelectorAll('.tabs-block__item');
                    if(lastClick){
                        lastClick.classList.remove('active');
                    }
                    items.forEach((item)=>{
                        item.classList.toggle('active',item.dataset.tag == tag)
                    })
                    tab.classList.add('active');
                    lastClick = tab;
                })
            })
            tabsPosts[0].click(); 
        }

        if(document.querySelector('.text-modules-wrapper .inside-intro-content')){
            let quadExtra = document.querySelector('.text-modules-wrapper');
            document.querySelector('.intro-content').appendChild(quadExtra);
            document.querySelector('.intro-content').classList.add('dining-page')
        }

        if(document.querySelector('.amenities-group-bg')){
            let quadExtra = document.querySelector('.amenities-group-bg');
            document.querySelector('.intro-content').appendChild(quadExtra);
            document.querySelector('.intro-content').classList.add('about-page')
        }

        /// menu ////

	let openMenu = document.getElementById("burgerMenu");
	if( openMenu ){
		openMenu.addEventListener("click", function() {
		document.querySelector(".js-navigation").classList.add("active");
		});
	}


	let closeMenu = document.querySelector(".close-menu");
	if(closeMenu){
		closeMenu.addEventListener("click", function() {
		document.querySelector(".js-navigation").classList.remove("active");
		});
	}


	if(document.querySelector('.attractions-content__right')) {
		  const rightDiv = document.querySelector('.attractions-content__right');

			window.addEventListener('scroll', () => {
				const scrollY = window.scrollY;
				const baseTop = window.innerHeight * 0.54;
				const newTop = baseTop - scrollY;
				const minTop = 0;
				rightDiv.style.top = `${Math.max(newTop, minTop)}px`;
			});

	}


})();

const customLightbox = new LBX('.js-lbx-custom', {
	customClass: 'normal-lbx'
});

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}